import { Component, computed, effect, EffectRef, OnDestroy } from "@angular/core";
import { AuthStoreService, LoginMode } from "../../services/auth-store/auth-store.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "@environments/environment";
import { Web3LoginFormComponent } from "../../components/web3-login-form/web3-login-form.component";
import { Web2LoginFormComponent } from "../../components/web2-login-form/web2-login-form.component";
import { CommonModule, NgClass } from "@angular/common";
import { ZertiauthApiService } from "../../services/auth-api/zertiauth-api.service";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { UserApiService } from "@features/users/infrastructure/services/user-api/user-api.service";
import Swal from "sweetalert2";
import { FormService } from "../../services/form.service";
import { InputPasswordComponent } from "../../components/input-password/input-password.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { AuthApiService } from "../../services/auth-api/auth-api.service";
import { QrGeneratorComponent } from "@shared/infrastructure/components/qr-generator/qr-generator.component";
import { NgbActiveModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { QrScannerComponent } from "@shared/components/qr-scanner/qr-scanner.component";


@Component({
  selector: "app-register-page",
  templateUrl: "./register-page.component.html",
  styleUrls: ["./register-page.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    NgClass,
    ReactiveFormsModule,
    InputPasswordComponent,
    NgSelectModule,
    QrGeneratorComponent,
    QrScannerComponent
], 
  providers: [NgbActiveModal]
})
export class RegisterPageComponent implements OnDestroy {

  user: any;
  availableRoles = ['FARM','ADMIN','VET','GUEST']; //TODO: get from backend

  profile: FormGroup = this.formBuilder.group({
    id: new FormControl<string | null>({ value: null, disabled: true }),
    username: new FormControl<string | null>(null, [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(20)
    ]),
    firstname: new FormControl<string | null>(null, [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(30)
    ]),
    lastname: new FormControl<string | null>(null, [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(30)
    ]),
    email: new FormControl<string | null>(null, [
      Validators.required,
      Validators.email
    ]),
    wallet_address: new FormControl<string | null>(null, [
      // Validators.required,
      Validators.minLength(42),
      Validators.maxLength(42)
    ]),
    desired_role: new FormControl<string | null>(null, [
      Validators.required
    ]),
    password: new FormControl<string | null>(null, [
      Validators.required,
      this.formService.passwordValidator()
    ])
  });


  protected readonly environment = environment;

  constructor(
    private authStore: AuthStoreService,
    private router: Router,
    private route: ActivatedRoute,
    private zertiauthApiService: ZertiauthApiService,
    private formBuilder: FormBuilder,
    private authService:AuthApiService,
    private formService:FormService) {

  }

  ngOnInit(): void {
    this.route.params.subscribe((params:any) => {
      const role = params['role']; // Access the role parameter
      if (this.availableRoles.includes(role)) {
        this.profile.patchValue({ desired_role: role }); // Set the role if valid
      }
    });
  }

  setValues(user: any) {
    this.profile.setValue({
      id: user.id || '',
      username: user.username || '',
      firstname: user.firstname || '',
      lastname: user.lastname || '',
      email: user.email || '',
      wallet_address: user.wallet_address || '',
      desired_role: user.desired_role || '',
      password: user.password || ''
    });
  }

  saveProfile() {

    this.profile.markAllAsTouched();

    if (this.profile.invalid) {
      Swal.fire({
        icon: 'error',
        title: 'Formulari invàlid'
      });
      return;
    }

    let user = this.getValues();

    this.authService.register(user).subscribe({
      next: res => {
        Swal.fire({
          icon: 'success',
          title: "Usuari registrat",
          timer:2000,
          willClose: () => {
            this.router.navigate(['/auth/login'])
          }
        });
      }, error: error => {
        console.log(error)
        Swal.fire('', 'Error registrant el perfil.', 'error')
      }
    })
  }

  getValues() {
    const values: any = {};
    // values.id = this.profile.value.id;
    values.username = this.profile.value.username;
    values.firstname = this.profile.value.firstname;
    values.lastname = this.profile.value.lastname;
    values.wallet_address = this.profile.value.wallet_address;
    values.email = this.profile.value.email;
    values.desired_role = this.profile.value.desired_role;
    values.password = this.profile.value.password;
    // values.role = this.profile.value.role;
    return values;
  }

  copyToClipboard(elementToCopy:any) {
    navigator.clipboard.writeText(elementToCopy).then(() => {
      Swal.fire({title:'copied','timer':1000,'showConfirmButton':false})
    }).catch(err => {
      console.error('Error al copiar el texto: ', err);
    });
  }

  onScanResult(scanResult: string) {
    // Update the form control wallet_address with the scanned value
    this.profile.get('wallet_address')?.setValue(scanResult);
  }

  ngOnDestroy() { }

}
